import React, {Component} from 'react'
import {Button, Input, Modal, notification} from 'antd'
import PropTypes from 'prop-types'
import {bulkExportByFieldId, exportLinkByNumber} from "../../../../../services/api/3dApi"

const {TextArea} = Input

class ExportLinksByName extends Component {
    state = {
        isOpen: true,
        total: 0,
    }

    _name = ''

    _handleChange = e => {
        const {value} = e.target

        this._name = value

        this._countTemplates()
    }

    _handleSubmit = e => {
        e.preventDefault()

        this._exportLinks().then(fileId => {
            window.open(bulkExportByFieldId(fileId))
        }).catch(err => {
            notification.error({
                message: 'ERROR',
                description: err.message,
                duration: 0,
            })
        })
    }

    _exportLinks = async () => {
        this.setState({loading: true})

        const payload = {
            templates: this._name,
        }

        const {data: response} = await exportLinkByNumber(payload)

        const {success, error, data} = response

        if (!success) {
            throw new Error(error)
        }

        return data.id
    }

    _renderModalFooter = () => {
        const buttonCancel = <Button key='btnCancelBulkAction2' onClick={this._closeModal}>Cancel</Button>
        const buttonOk = <Button key='btnOKBulkAction2' type='primary' onClick={this._handleSubmit}>OK</Button>

        return [buttonCancel, buttonOk]
    }

    _closeModal = () => {
        this.setState({
            isOpen: false,
        })
    }

    _handleAfterClose = () => {
        this.props.onResetAction()
    }

    _countTemplates = () => {
        const arr = this._name.split(/\r|\n|\t|\r\n/)
        const arrFiltered = arr.filter(Boolean)

        this.setState({
            total: arrFiltered.length,
        })
    }

    render() {
        const {isOpen, total} = this.state
        const modalFooter = this._renderModalFooter()

        return (
            <Modal visible={isOpen} title='Xuất link files theo tên' footer={modalFooter} className='BulkMarkAsPrinted'
                   afterClose={this._handleAfterClose} onCancel={this._closeModal}>
                <label htmlFor='listTemplateIds' className='fs-16'>
                    Nhập tên templates theo từng dòng
                </label>
                <TextArea rows={6} onChange={this._handleChange} placeholder='123456_7'/>
                <div className='mt-2'>
                    Đã nhập: <span className='font-weight-bold'>{total} items</span>
                </div>
            </Modal>
        )
    }
}

ExportLinksByName.propTypes = {
    onResetAction: PropTypes.func.isRequired,
}

export default ExportLinksByName
